var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 50H50V12.5C50 11.837 49.7366 11.2011 49.2678 10.7322C48.7989 10.2634 48.163 10 47.5 10C46.837 10 46.2011 10.2634 45.7322 10.7322C45.2634 11.2011 45 11.837 45 12.5V50H40V32.5C40 31.837 39.7366 31.2011 39.2678 30.7322C38.7989 30.2634 38.163 30 37.5 30C36.837 30 36.2011 30.2634 35.7322 30.7322C35.2634 31.2011 35 31.837 35 32.5V50H30V22.5C30 21.837 29.7366 21.2011 29.2678 20.7322C28.7989 20.2634 28.163 20 27.5 20C26.837 20 26.2011 20.2634 25.7322 20.7322C25.2634 21.2011 25 21.837 25 22.5V50H20V42.5C20 41.837 19.7366 41.2011 19.2678 40.7322C18.7989 40.2634 18.163 40 17.5 40C16.837 40 16.2011 40.2634 15.7322 40.7322C15.2634 41.2011 15 41.837 15 42.5V50H10V7.5C10 6.83696 9.73661 6.20107 9.26777 5.73223C8.79893 5.26339 8.16304 5 7.5 5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V52.5C5 53.163 5.26339 53.7989 5.73223 54.2678C6.20107 54.7366 6.83696 55 7.5 55H52.5C53.163 55 53.7989 54.7366 54.2678 54.2678C54.7366 53.7989 55 53.163 55 52.5C55 51.837 54.7366 51.2011 54.2678 50.7322C53.7989 50.2634 53.163 50 52.5 50Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGraph);
export default __webpack_public_path__ + "static/media/no-graph.695b1adc4b6a7d12067107eb655882ba.svg";
export { ForwardRef as ReactComponent };